import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './Navbar';
import SparklingBackground from './Background';

function App() {
  return (
    <div className="App">
      <SparklingBackground/>
     <Navbar/>
    </div>
  );
}


export default App;
